/**
  * 产品分类 接口的出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const numprocate = {
    // 列表
    list (params) {
        return axios.get(api + 'numprocate/list', { params: params })
    },
    //添加
    create (params) {
        return axios.post(api + 'numprocate/create', qs.stringify(params))
    },
    //获取编辑信息
    detail (params) {
        return axios.get(api + 'numprocate/detail', { params: params })
    },
    //修改
    edit (params) {
        return axios.post(api + 'numprocate/edit', qs.stringify(params))
    },
    //删除
    remove (params) {
        return axios.post(api + 'numprocate/remove', qs.stringify(params))
    }
}


// 导出接口
export default numprocate
